/* DON'T EDIT THIS FILE: edit original and run build again */ export const canChangeToAllowedTenant = "canChangeToAllowedTenant";
export const canChangeToAnyTenant = "canChangeToAnyTenant";
export const canSeeOtherEndClients = "canSeeOtherEndClients";
export const canViewTenantSettings = "canViewTenantSettings";
export const canEditTenantSettings = "canEditTenantSettings";
export const canViewSemaphoreSettings = "canViewSemaphoreSettings";
export const canEditSemaphoreSettings = "canEditSemaphoreSettings";
